import React from 'react';

const Checkout = () => {
    return (
        <div className='min-screen-height'>
             <h1>Congrats! You Have got the premium access.</h1>
        </div>
    );
};

export default Checkout;